<template>
  <div v-if="isVisible" class="spinner-container show">
    <div class="spinner-1"></div>
    <div class="spinner-2"></div>
    <div class="spinner-3"></div>
    <div class="spinner-4"></div>
    <div class="spinner-5"></div>
    <div class="spinner-6"></div>
    <div class="spinner-7"></div>
    <div class="spinner-8"></div>
    <div class="spinner-9"></div>
    <div class="spinner-10"></div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { defineProps } from "vue";

// Props passed from parent
const props = defineProps({
  show: Boolean,
});

// Reactive variable to control visibility
const isVisible = ref(false);

// Watch the 'show' prop for changes and update 'isVisible'
watch(
  () => props.show,
  (newVal) => {
    isVisible.value = newVal;
  },
  { immediate: true } // Ensures visibility state is updated on initial render
);
</script>

<style>
.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-3 {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  border-radius: 50%;
  background: linear-gradient(0deg,
      rgba(245, 130, 32, 0.5) 30%,
      #0000 0 70%,
      rgba(245, 130, 32, 1) 0) 50% / 8% 100%,
    linear-gradient(90deg,
      rgba(245, 130, 32, 0.75) 30%,
      #0000 0 70%,
      rgba(245, 130, 32, 0.75) 0) 50% / 100% 8%;
  background-repeat: no-repeat;
  animation: s3 1s infinite steps(12);
}

.spinner-3::before,
.spinner-3::after {
  content: "";
  grid-area: 1/1;
  border-radius: 50%;
  background: inherit;
  opacity: 0.915;
  transform: rotate(30deg);
}

.spinner-3::after {
  opacity: 0.83;
  transform: rotate(60deg);
}

@keyframes s3 {
  100% {
    transform: rotate(1turn);
  }
}
</style>
